// external scripts
import $ from "jquery";
import debug from "bows";

import size from "./base/_size";

const log = debug('google-translate');

export default class {

	constructor( opts ) {

		this.opts = $.extend({
			element: '',
			mobile: '',
			desktop: '',
			translateOps: {}
		}, opts);

		this.opts.element = size.getWidth() < 1000 ? this.opts.mobile : this.opts.desktop;

		window.googleTranslateElementInit = this.googleTranslateElementInit;

		let script = document.createElement("script");
		script.src = '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit'; //Set it's src to the provided URL
		document.body.appendChild(script);

		window.gTranslate = this;
	}

	googleTranslateElementInit() {

		let self = window.gTranslate;

		let translateOps = $.extend({
			pageLanguage: 'en',
			includedLanguages: 'en,fr',
			layout: google.translate.TranslateElement.InlineLayout.SIMPLE
		} , self.translateOps );


		log(translateOps, self.opts.element);

		if (self.opts.element && $('#' + self.opts.element).length) {
			log('loaded: ' + self.opts.element)
			new google.translate.TranslateElement(translateOps, self.opts.element);
		}

	}



}


